<i class="bi bi-hourglass-split" [ngClass]="{ 'd-none': !show }"></i>
